import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface NavbarSearchState {
  id: symbol;
  placeholder: string;
  term: string;
}

@Injectable({ providedIn: 'root' })
export class NavbarSearchService {
  private stateSubject = new BehaviorSubject<NavbarSearchState | null>(null);

  readonly state$: Observable<NavbarSearchState | null> =
    this.stateSubject.asObservable();

  registrar(config: { placeholder: string; termoInicial?: string }): symbol {
    const id = Symbol('navbar-search');
    this.stateSubject.next({
      id,
      placeholder: config.placeholder,
      term: config.termoInicial ?? '',
    });
    return id;
  }

  atualizarTermo(term: string, id?: symbol): void {
    const atual = this.stateSubject.value;
    if (!atual) return;
    if (id && atual.id !== id) return;
    if (atual.term === term) return;
    this.stateSubject.next({ ...atual, term });
  }

  atualizarPlaceholder(placeholder: string, id?: symbol): void {
    const atual = this.stateSubject.value;
    if (!atual) return;
    if (id && atual.id !== id) return;
    if (atual.placeholder === placeholder) return;
    this.stateSubject.next({ ...atual, placeholder });
  }

  limpar(id: symbol): void {
    const atual = this.stateSubject.value;
    if (atual && atual.id === id) {
      this.stateSubject.next(null);
    }
  }

  obterEstadoAtual(): NavbarSearchState | null {
    return this.stateSubject.value;
  }
}
